import { Component, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { GalaxyDataService } from '../services/galaxy-data.service';
import { GalaxyNode, GalaxyNodeType } from '../models/galaxy-node';
import { Galaxy, GalaxyParams } from '../models/galaxy';
import { GalaxyRenderer } from '../rendering/galaxy-renderer';

@Component({
  selector: 'app-galaxy-view',
  templateUrl: './galaxy-view.component.html',
  styleUrls: ['./galaxy-view.component.scss'],
})
export class GalaxyViewComponent implements AfterViewInit {
  @ViewChild('graphContainer', { static: true }) graphElement!: ElementRef<HTMLDivElement>;
  private galaxy: Galaxy;
  private galaxyRenderer: GalaxyRenderer;

  public selectedNode: GalaxyNode | null = null;

  constructor(private galaxyDataService: GalaxyDataService) {}

  ngAfterViewInit() {
    const typeMap = new Map<string, GalaxyNodeType>([
      ['technology', GalaxyNodeType.SPIRAL],
      ['mainConcept', GalaxyNodeType.CLUSTER],
      ['subConcept', GalaxyNodeType.STAR],
      ['project', GalaxyNodeType.PLANET],
    ]);
    const ringMap = new Map<string, number>([
      ['Identified', 3],
      ['Asses', 2],
      ['Trial', 1],
      ['Adopt', 0],
    ]);
    this.galaxyDataService.fetchData('assets/technologies_view_data.json', typeMap, ringMap).subscribe((data) => {
      const params: GalaxyParams = {
        spiralArmCount: 1,
        spiralTurnCount: 2,
        clusterCountPerArm: 15,
        clusterRadiusMin: 400,
        clusterRadiusMax: 1000,
        starRadiusMin: 50,
        starRadiusMax: 100,
        planetRadiusMin: 5,
        planetRadiusMax: 10,
        ringSpacing: 2,
      };
      this.galaxy = new Galaxy(data, params);
      this.galaxyRenderer = new GalaxyRenderer(this.graphElement.nativeElement, this.galaxy);
      this.galaxyRenderer.nodeSelected.subscribe((node) => {
        this.selectedNode = node;
      });
    });
  }

  closeInfoBox() {
    this.selectedNode = null;
  }

  resetView() {
    this.galaxyRenderer.resetView();
  }
}
